import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@shared/services/toast.service';
import { take, tap } from 'rxjs';

export const RoleGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastService);
  const translateService = inject(TranslateService);
  const router = inject(Router);
  const location = inject(Location);

  const roles: string[] = route.data['roles'];
  const currentUrl = state.url;
  
  return authService.hasRoles(roles).pipe(
    take(1),
    tap((hasRoles) => {
      if (!hasRoles) {
        const isAlreadyOnRoute = router.url === currentUrl;
        if (!isAlreadyOnRoute) {
          translateService.get('shared.error.access-denied').subscribe({
            next: (msg) => toastService.error(msg),
          });
          router.navigate([]);
        }
      }
    }),
  );
};
